import t from"react";import{mdiClose as o}from"@mdi/js";import{MdIcon as e}from"./MdIcon.js";const r=({id:r="close",title:i="Close",...m})=>t.createElement(e,{id:r,title:i,path:o,...m});export{r as CloseIcon};
